import React, { useState } from "react";
import { Tooltip, FormFeedback } from "reactstrap";

const SwitchInput = ({
  label = "Toggle Option",
  id = "switchInput",
  name = "switch",
  required = false,
  checked = false, // Controlled state passed from Formik
  onText = "On",
  offText = "Off",
  onChange = () => {},
  showHelp = false,
  helpText = "Toggle the switch.",
  requiredErrorMessage = "This field is required.",
  customErrorMessages = {},
  layout = "below",
  size = "medium",
  fontSize = "16px",
  labelColor = "black",
  switchColor = "#2196F3",
  switchOffColor = "#ccc",
  visible = true,
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [error, setError] = useState("");

  const validateSwitch = () => {
    if (required && !checked) {
      setError(customErrorMessages.required || requiredErrorMessage);
      return false;
    }
    setError("");
    return true;
  };

  const handleSwitchChange = (e) => {
    const newChecked = e.target.checked;
    onChange(newChecked); // Pass the updated value to parent
    validateSwitch();
  };

  if (!visible) return null;

  // Size settings
  let switchWidth, switchHeight, switchCircleSize;
  switch (size) {
    case "small":
      switchWidth = "40px";
      switchHeight = "24px";
      switchCircleSize = "20px";
      break;
    case "medium":
      switchWidth = "60px";
      switchHeight = "34px";
      switchCircleSize = "26px";
      break;
    case "large":
      switchWidth = "80px";
      switchHeight = "44px";
      switchCircleSize = "34px";
      break;
    default:
      switchWidth = size;
      switchHeight = parseInt(size) * 0.6 + "px";
      switchCircleSize = (parseInt(size) * 0.5) + "px";
  }

  return (
    <div className={layout === "inline" ? "d-flex align-items-center mb-2" : "mb-2"}>
      <label
        htmlFor={id}
        style={{ width: layout === "inline" ? "20%" : "100%", color: labelColor, fontSize: fontSize }}
        className="d-flex"
      >
        {label} {required && <span className="text-danger">*</span>}
        {showHelp && (
          <span id="helpTooltip" className="px-2">
            <i className="ri-question-line" style={{ cursor: "pointer", fontSize: "16px" }}></i>
          </span>
        )}
      </label>

      {showHelp && (
        <Tooltip
          placement="right"
          isOpen={tooltipOpen}
          target="helpTooltip"
          toggle={() => setTooltipOpen(!tooltipOpen)}
        >
          {helpText}
        </Tooltip>
      )}

      <div className="w-100" style={{ display: "flex", alignItems: "center" }}>
        <label style={{ position: "relative", display: "inline-block", width: switchWidth, height: switchHeight }}>
          <input
            type="checkbox"
            id={id}
            name={name}
            checked={checked} // Controlled component
            onChange={handleSwitchChange}
            style={{ display: "none" }}
          />
          <span
            style={{
              position: "absolute",
              cursor: "pointer",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: checked ? switchColor : switchOffColor,
              transition: ".4s",
              borderRadius: "34px",
            }}
          />
          <span
            style={{
              position: "absolute",
              height: switchCircleSize,
              width: switchCircleSize,
              left: checked ? `calc(${switchWidth} - ${switchCircleSize})` : "4px",
              bottom: "4px",
              backgroundColor: "#fff",
              transition: ".4s",
              borderRadius: "50%",
              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.2)",
            }}
          />
        </label>
        <span className="ml-2" style={{ fontSize: fontSize }}>
          {checked ? onText : offText}
        </span>
      </div>

      {error && <FormFeedback type="invalid">{error}</FormFeedback>}
    </div>
  );
};

export default SwitchInput;
